import React from 'react';
import style from './Submenu.module.css';
import classes from 'react-style-classes';

var Submenu = function Submenu(_ref) {
  var children = _ref.children,
      position = _ref.position,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classes(style.submenu, position === 'right' && style.submenuRight, className)
  }, /*#__PURE__*/React.createElement("ul", null, children));
};

Submenu.defaultProps = {
  children: null,
  position: 'left',
  className: null
};
export default Submenu;